import Vue from "vue";
import ElementUI from 'element-ui';
import MDesign from 'mdesign';
import 'element-ui/lib/theme-chalk/index.css';
import 'mdesign/lib/style/index.css';

import App from "./App.vue";
import mxService from "./mx-service";
import locale from "./mx-service/libs/locale";
import "./mx-service/index.less";
// import "./mock";
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(MDesign);

(async () => {
  const i18n = await locale.getLocale();
  new Vue({
    router: mxService.router,
    store: mxService.store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
})();
